<div class="bp-modal-body-section">
  <div class="text-center">
    <!-- Text -->
    <div class="mb-15 text-medium-black">{{ descriptionKey | translate }}</div>
    <!-- Resend PIN -->
    <div class="mb-40">
      <a (click)="createPinRequest('sms')">{{ "resend_sms_code" | translate }} </a>
    </div>
    <!-- Input -->
    <div class="mb-40">
      <form class="mb-10">
        <input
          class="form-field-enhanced mod-two-fa input-lg"
          [class.input-text-mask]="inputSecurity"
          name="random-pin"
          [(ngModel)]="verificationPin._code"
          bp-type="{{ inputBpType }}"
          [formatted-output]="false"
          [focus]="true"
          (input)="autoAccept()"
          [maxlength]="pinLength" />
      </form>
    </div>
    <!-- Voice call -->
    @if (voiceCallEnabled) {
      <div>
        <a (click)="createPinRequest('voicecall')">{{ "request_voice_call_instead_sms_code" | translate }} </a>
      </div>
    }
  </div>
</div>
